import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { RepCoachingGoals } from '../types';

/**
 * Hook for fetching rep coaching goals by user ID
 */
export function useRepCoachingGoals(userId: string) {
	const userSession = useUserSession();

	return useQuery({
		queryKey: ['repCoachingGoals', userId],
		queryFn: async (): Promise<RepCoachingGoals> => {
			const response = await userSession.webServiceHelper.callWebServiceAsync<RepCoachingGoals>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `aida/repCoachingGoals/byUser/${userId}`,
				}),
				'GET'
			);

			// Return defaults if no goals are set
			if (!response.value) {
				return {
					workingOn: '',
					tysonMaxDifficulty: 1, // Easy
				};
			}

			return {
				id: response.value.id,
				userId: response.value.userId,
				workingOn: response.value.workingOn || '',
				tysonMaxDifficulty: response.value.tysonMaxDifficulty || 1,
			};
		},
		enabled: !!userId,
	});
}
